<template>
    <div v-if="!$helper.isEmpty(invoiceDetail)"
        class="mobile:max-w-full laptop:max-w-[950px] mx-auto flex flex-col items-center py-3 relative"
        :class="{ 'mt-[60px]': $route.query.is_from_mobile != 1 }">
        <div class="w-[70%] m-auto text-center">
            <h4 class="text-2xl font-bold mb-0 text-[#092E87] !leading-[24px]">Payment Method</h4>
            <p class="mobile:text-sm laptop:text-base font-normal mb-0 text-[#666666] !leading-[15px]">{{
                !isApproved ? 'Please select your preferred payment options' :
                    'No balance is due. Please provide your approval to proceed.' }}</p>
        </div>
        <!-- Tabs -->
        <div v-if="!isApproved" ref="tabContainer"
            class="flex tablet:justify-center gap-2.5 mt-2 w-full overflow-auto py-3 customscrolbar"
            :class="tabs.length <= 3 ? 'mobile:justify-center' : 'mobile:justify-start'">
            <button v-for="(tab, index) in tabs" :key="index" :ref="el => tabRefs[tab.id] = el"
                @click="tabClicked(tab.id)"
                class="px-3.5 py-2.5 min-w-28 text-sm font-medium whitespace-nowrap shrink-0 focus:outline-none rounded-full transition-all relative"
                :class="activeTab == tab.id
                    ? 'border border-[#FE5000] text-white bg-[#FE5000]'
                    : 'border border-[#CCCCCC] text-black-100 bg-[#F1F1F1] laptop:hover:text-white laptop:hover:bg-[#FE5000]'">
                {{ tab.title }}
            </button>
        </div>

        <div class="mobile:p-2 laptop:p-5 mt-3.5 w-full rounded-[20px] border border-[#CCCCCC]">
            <div class="mobile:block laptop:flex gap-4 w-full mobile:min-h-[unset] laptop:min-h-[350px] mb-5">
                <!-- qoute detail box-->
                <quoteDetailBox :invoice-detail="invoiceDetail" />
                <div
                    class="min-h-full mobile:w-full laptop:w-2/3 py-3 px-[20px] mobile:mt-3 laptop:mt-0 rounded-[20px] shadow-custom bg-white">
                    <div class="min-h-full" v-if="!isApproved">

                        <creditCardComponent v-if="activeTab === 0 && invoiceDetail.is_payable" ref="tab-0"
                            :stripe_id="invoiceDetail.stripe_id" @validation-change="isValid = $event" />
                        <!-- Cash -->
                        <cashComponent v-else-if="activeTab === 1" ref="tab-1" :invoice-detail="invoiceDetail" />
                        <!-- Check -->
                        <checkComponent v-else-if="activeTab === 2" ref="tab-2" @validation-change="isValid = $event" />
                        <!-- financing -->
                        <financingComponent v-else-if="activeTab === 3" ref="tab-3"
                            @validation-change="isValid = $event" :invoiceDetail="invoiceDetail"
                            :financialInstitutes="financialInstitutes" :callback="financialCallback"
                            :linkGenerated="linkGenerated" :stripURL="stripURL" />
                        <!-- financing -->
                        <!-- financing -->
                        <div v-else-if="activeTab === 4 && !linkGenerated" ref="tab-4"
                            class="min-h-full gap-3 pt-[30px]">
                            <p class="text-[16px] font-roboto text-[#333] mb- text-center">Click <span
                                    class="font-bold">Generate Link</span> to
                                create your payment link. The link will appear here once generated.
                            </p>
                            <button @click="generateLinkClicked()"
                                class="m-0  !mt-[20px] block mx-auto rounded-full px-[20px] py-[5px] !border-[1px] border-[#FE5000] text-[#fff] bg-[#FE5000]">Generate
                                Link</button>
                        </div>
                        <div v-else-if="activeTab === 4 && linkGenerated" ref="tab-4"
                            class="min-h-full flex flex-col gap-3 mb-[3rem]">
                            <div class="flex justify-start items-center gap-1 w-full">
                                <div class="w-2 h-2 rounded-full bg-[#FE5000]"></div>
                                <div class="w-9 h-2 rounded-full bg-[#FE5000]"></div>
                                <p class="text-xl font-bold pl-2 m-0 text-[#092E87]">Financing</p>
                            </div>

                            <div>
                                <div class="w-full py-1">
                                    <p class="text-lg font-normal leading-[20px] mb-[15px] text-[#333333]">Use this
                                        payment link to make an online payment. You can get financing through this
                                        option.</p>
                                </div>
                                <div
                                    class="relative w-full h-[35px] 2xl:h-[42px] rounded-md 2xl:rounded-lg !border !border-[#CCCCCC] bg-[#EFEFEF80]">
                                    <input type="text" :value="stripURL"
                                        class="w-full h-full p-1.5 2xl:p-2.5 !border-0 outline-none !text-[14px] largeDesktop:text-base !text-[#333333] "
                                        disabled>
                                    <button @click="copysharelink"
                                        class="absolute top-0 -right-[1px] h-full w-[34px] 2xl:w-[42px] rounded-r-md 2xl:rounded-r-lg flex items-center justify-center bg-[#092E87]">
                                        <img src="../../assets/images/copy-icon.png" alt="Share Icon"
                                            class="w-4 h-4 2xl:w-6 2xl:h-6">
                                    </button>
                                </div>
                                <div class="flex flex-col gap-[15px] laptop:gap-[10px] mt-[3rem]">
                                    <div>
                                        <h4 class="text-[#092E87] text-[14px] font-bold mb-[5px]">Instructions:</h4>
                                        <ul class="list-none p-0 mt-[5px] mb-0">
                                            <li class="flex items-center gap-[3px] text-[12px] font-normal">
                                                <span>
                                                    <img src="../../assets/images/ins-arrow.png" alt="arrow icon"
                                                        class="object-cover w-[14px] h-[14px]" />
                                                </span>
                                                Click Continue to get financing.
                                            </li>
                                        </ul>
                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>
                    <!-- approved -->
                    <div v-else class="min-h-full flex flex-col gap-3">
                        <div class="flex justify-start items-center gap-1 w-full">
                            <div class="w-2 h-2 rounded-full bg-[#FE5000]"></div>
                            <div class="w-9 h-2 rounded-full bg-[#FE5000]"></div>
                            <p class="text-xl font-bold pl-2 m-0 text-[#092E87]">Approval</p>
                        </div>
                        <div class="w-full py-2">
                            <p class="text-lg font-normal leading-[20px] text-[#333333]"><span class="font-bold">${{
                                $helper.formatAmount(invoiceDetail?.amount ?? '0') }}</span> due today. Provide
                                approval to proceed</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- signing -->
            <div v-if="activeTab != 4 && !isSignatureDisable"
                class="flex mobile:items-start laptop:items-center mt-[20px]">
                <label class="flex mobile:items-start tablet:items-center cursor-pointer">
                    <input type="checkbox" v-model="checkbox" class="hidden peer" />
                    <!-- custom box -->
                    <span
                        class="min-w-7 min-h-7 flex items-center justify-center border-[1px] !border-[#092E87] rounded-md transition">
                        <!-- tick -->
                        <svg v-if="checkbox == true" class="w-6 h-6 text-[#092E87]" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 20 20">
                            <path d="M5 10.5 8.5 14 15 7.5" />
                        </svg>
                    </span>
                </label>
                <!-- label text -->
                <span v-if="isApproved" class="ml-2 text-sm font-normal text-[#666666]">By signing, I confirm that I
                    have
                    reviewed and approved this quote.</span>
                <span v-else class="ml-2 text-xs text-[#666666]">By signing, I confirm that I
                    have
                    approved this quote and authorize the technician to complete checkout on my behalf.</span>
            </div>

            <!-- Consumer Signature -->
            <div v-if="!isSignatureDisable" class="w-full py-[20px]">
                <div class="flex items-center justify-between w-full pb-1.5">
                    <label for="consumersignature" class="text-base text-[#666666]">Consumer Signature<span
                            class="ml-1 text-red-500">*</span></label>
                    <button type="button" @click="clearSignature" :disabled="!isSignatureValid" class="group text-sm mobile:w-6 mobile:h-6 laptop:w-[75px] laptop:h-6 flex justify-center items-center gap-1.5 transition-all rounded-full border-[1px] border-[#FE5000] mobile:bg-[#FE5000] laptop:bg-transparent hover:bg-[#FE5000] 
                        disabled:hover:!bg-[#EFEFEF]  disabled:bg-[#EFEFEF] disabled:border-[#EFEFEF]">
                        <span
                            class="laptop:flex mobile:hidden group-hover:text-white text-[#FE5000] group-disabled:text-[#999999] group-disabled:hover:text-[#999999]">
                            Clear
                        </span>
                        <img src="../../assets/images/razer-icon.png" alt="razer icon"
                            class="w-[14px] h-[14px] object-contain filter group-disabled:invert-[60%] group-disabled:brightness-0 group-hover:invert group-hover:brightness-0 mobile:brightness-0 laptop:brightness-[unset] mobile:invert laptop:invert-[unset] ">
                    </button>
                </div>
                <div class="w-full h-[100px]">
                    <VueSignaturePad height="100%" width="100%" ref="signaturePad" :options="{
                        onBegin: onBegin,
                        onEnd: onEnd
                    }"
                        class="!text-base font-medium border border-[#cccccc] outline-none py-2 px-3 w-full rounded-lg placeholder:text-[#cccccc] text-#666666 resize-none" />
                </div>
            </div>

            <div class="flex justify-center items-center gap-3 py-2">
                <button type="button" @click="backClicked"
                    class="text-base w-36 h-10 flex justify-center items-center transition-all rounded-full border-[1px] border-[#FE5000] mobile:bg-[#FE5000] laptop:bg-transparent mobile:text-white laptop:text-[#FE5000] hover:bg-[#FE5000] hover:text-white
                    disabled:hover:!bg-transparent disabled:hover:text-unset disabled:bg-transparent disabled:text-[#CCCCCC] disabled:border-[#CCCCCC]">Back</button>
                <button v-if="!isApproved" type="button" @click="payButtonClicked" :disabled="isButtonDisable"
                    class="text-base w-36 h-10 flex justify-center items-center transition-all rounded-full border-[1px] border-[#092E87] mobile:bg-[#092E87] laptop:bg-transparent mobile:text-white laptop:text-[#092E87] hover:bg-[#092E87] hover:text-white
                    disabled:hover:!bg-transparent disabled:hover:text-unset disabled:bg-transparent disabled:text-[#CCCCCC] disabled:border-[#CCCCCC]">{{ isSignatureDisable ? 'Continue' : 'Pay' }}</button>
                <!-- approved btn -->
                <button v-else type="button" @click="approvedButtonClicked" :disabled="isApprovedButtonDisable"
                    class="text-base w-36 h-10 flex justify-center items-center transition-all rounded-full border-[1px] border-[#092E87] mobile:bg-[#092E87] laptop:bg-transparent mobile:text-white laptop:text-[#092E87] hover:bg-[#092E87] hover:text-white
                        disabled:hover:!bg-transparent disabled:hover:text-unset disabled:bg-transparent disabled:text-[#CCCCCC] disabled:border-[#CCCCCC]">Approve</button>
            </div>
        </div>
        <!-- back button just for desktop-->
        <div v-if="false" class="mobile:hidden laptop:flex justify-center items-center py-3">
            <button type="button" @click="backClicked"
                class="text-base py-1.5 px-5 transition-all rounded-full border-[1px] border-[#092E87] text-[#092E87] hover:bg-[#092E87] hover:text-white">Back</button>
        </div>
        <!-- back button just for mobile screens-->
        <div v-if="false" class="mobile:flex laptop:hidden justify-center items-center py-3">
            <button type="button" @click="backClicked"
                class="absolute left-1 top-7 h-8 w-8 p-2 flex justify-center items-center border-0 shadow-custom rounded-full">
                <img src="../../assets/images/backarrow-blue.png" class="img-fluid" alt="back arrow">
            </button>
        </div>
    </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from "vuex";

import cashComponent from '../../components/checkout/cashComponent.vue';
import checkComponent from '../../components/checkout/checkComponent.vue';
import creditCardComponent from '../../components/checkout/creditCardComponent.vue';
import financingComponent from '../../components/checkout/financingComponent.vue';
import quoteDetailBox from '../../components/checkout/quoteDetail.vue';
import { globals } from "../../main";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {

    components: {
        creditCardComponent,
        cashComponent,
        checkComponent,
        financingComponent,
        quoteDetailBox
    },
    data() {
        return {
            checkbox: false,
            activeTab: 0,
            tabs: [
                { title: "Credit Card", id: 0 },
                { title: "Cash", id: 1 },
                { title: "Check", id: 2 }
            ],
            invoice_id: this.$route.params.id,
            isValid: false,
            isSignatureValid: false,
            signationImageFile: null,
            saveSignatureTimeout: null,
            tabRefs: {},
            linkGenerated: false,
            stripURL: '',
            ccPayload: {},
            isSignatureDisable: false
        }
    },
    computed: {
        ...mapGetters(["paymentLinkResponse", "creditCardIDResponse", "invoiceDetail", "quoteCheckoutResponse", "signaturePaymentLinkResponse", "financialInstitutes"]),

        isApproved() {
            return !this.invoiceDetail.amount > 0
        },

        isButtonDisable() {
            if (this.isSignatureDisable) {
                if (this.stripURL.length <= 0) {
                    return true
                }
                return;
            }
            else {
                return !(this.checkbox && this.isValid && this.isSignatureValid)
            }
        },

        isApprovedButtonDisable() {
            return !(this.checkbox && this.isSignatureValid)
        }
    },

    watch: {
        financialInstitutes: function () {

        },

        paymentLinkResponse: function () {
            this.stripURL = this.paymentLinkResponse.session_url
            this.linkGenerated = this.stripURL.length > 0
            if (!this.linkGenerated) {
                toast.error("Problem while generating strip link.")
            }
        },

        creditCardIDResponse: function () {
            globals.$loader.show();
            this.ccCheckout(this.ccPayload)
        },

        invoiceDetail: function () {
            if (this.invoiceDetail.is_payable == 0) {
                toast.error("Job is not payable or has already been checked out.")
                this.$router.go(-1)
            } else {
                this.tabs = [
                    { title: "Credit Card", id: 0 },
                    { title: "Cash", id: 1 },
                    { title: "Check", id: 2 },
                    { title: "Financing", id: 3 }
                ]

                if (this.invoiceDetail) {
                    this.activeTab = this.invoiceDetail.preferred_payment_type == 'other' ? 3 : this.invoiceDetail.preferred_payment_type == 'check' ? 2 : this.invoiceDetail.preferred_payment_type == 'cash' ? 1 : 0
                }
            }
        },

        activeTab: function () {
            if (this.activeTab == 0 || this.activeTab == 2 || this.activeTab == 3) {
                this.isValid = false
            } else {
                this.isValid = true
            }

            // scroll logic
            this.$nextTick(() => {
                const el = this.tabRefs[this.activeTab]   // ✅ direct id se access
                if (el) {
                    el.scrollIntoView({
                        behavior: "smooth",
                        inline: "center",
                        block: "nearest"
                    })
                }
            })
        },

        signaturePaymentLinkResponse: function () {
            window.location.href = this.stripURL
        },

        quoteCheckoutResponse: function () {
            if (this.quoteCheckoutResponse.error_code == 'err_already_checked_out') {
                this.$router.go(-1)
                toast.error(this.quoteCheckoutResponse.message);
            } else if (this.quoteCheckoutResponse.status == true) {
                if (this.$route.query.is_from_mobile == '1') {

                    let redirectTo = localStorage.getItem("redirect_to") ?? ''
                    if (redirectTo == 'job_invoice') {
                        this.$router.go(-1)
                    }
                    else {
                        this.$router.replace({
                            name: 'checkoutSuccess',
                            query: {
                                is_from_mobile: Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0
                            },
                        });
                    }
                } else {
                    toast.success("Your checkout was successful!")
                    this.$router.go(-1)
                }
            } else {
                toast.error(this.quoteCheckoutResponse.message);
            }
        },

    },

    mounted() {
        this.getInvoiceDetail({
            invoice_id: this.$route.params.id
        });

        this.getFinancialInstitutes({
            invoice_id: this.$route.params.id
        })
    },

    methods: {
        ...mapActions(["generatePaymentLink", "getCreditCardID", "getInvoiceDetail", "postCheckout", "uploadSignaturePaymentLink", "getFinancialInstitutes"]),

        generateLinkClicked() {
            this.generatePaymentLink({
                id: this.$route.params.id
            });
        },

        backClicked() {

            let redirectTo = localStorage.getItem("redirect_to") ?? ''
            if (this.$route.query.is_from_mobile == '1') {
                if (redirectTo == 'job_invoice') {
                    this.$router.go(-1)
                }
                else {
                    this.$router.replace({
                        name: 'checkoutFailed',
                        query: {
                            is_from_mobile: Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0
                        },
                    });
                }

            } else {
                this.$router.go(-1)
            }
        },

        approvedButtonClicked() {
            this.$dialog.show({
                title: "Approve",
                text: "Are you sure you want to approve this quote?",
                onConfirm: () => {
                    this.cashCheckout()
                },
            });

        },

        checkValidation() {
            let currentRef = this.$refs[`tab-${this.activeTab}`]
            if (currentRef && currentRef.checkValidation) {
                return currentRef.checkValidation()
            } else {
                return true
            }
        },

        async checkCreditCard() {

            //new api implement here

            globals.$loader.show();

            let payload = await this.$refs[`tab-${this.activeTab}`].getData()
            this.ccPayload = payload

            this.getCreditCardID({
                invoice_id: this.$route.params.id,
                card_token: payload.token.id
            });

        },

        async payButtonClicked() {
            if (this.checkValidation()) {
                if (this.activeTab == 0) {
                    this.$dialog.show({
                        title: "Confirm Checkout",
                        text: "Are you sure you want to move forward with checkout?",
                        onConfirm: () => {
                            this.checkCreditCard()
                        },
                    });
                } else if (this.activeTab == 1) {
                    this.$dialog.show({
                        title: "Confirm Checkout",
                        text: "Are you sure you want to move forward with checkout?",
                        onConfirm: () => {
                            this.cashCheckout()
                        },
                    });
                } else if (this.activeTab == 2) {
                    let payload = await this.$refs[`tab-${this.activeTab}`].getData()
                    this.$dialog.show({
                        title: "Confirm Checkout",
                        text: "Are you sure you want to move forward with checkout?",
                        onConfirm: () => {
                            this.checkCheckout(payload)
                        },
                    });
                } else if (this.activeTab == 3) {
                    let payload = await this.$refs[`tab-${this.activeTab}`].getData()
                    if (payload?.type == 'PaymentLink') {
                        this.$dialog.show({
                            title: "Confirm Your Payment",
                            text: "By continuing, you will be redirected to our secure Stripe Checkout page to complete your payment.",
                            onConfirm: () => {
                                this.uploadSignaturePaymentLinkCall()
                            },
                        });
                    } else {
                        this.$dialog.show({
                            title: "Confirm Checkout",
                            text: "Are you sure you want to move forward with checkout?",
                            onConfirm: () => {
                                this.otherCheckout(payload)
                            },
                        });
                    }

                } else if (this.activeTab == 4) {
                    this.$dialog.show({
                        title: "Confirm Your Payment",
                        text: "By continuing, you will be redirected to our secure Stripe Checkout page to complete your payment.",
                        onConfirm: () => {
                            this.uploadSignaturePaymentLinkCall()
                        },
                    });
                }
            }

        },

        cashCheckout() {
            let signatureFile = this.getSignature()
            if (!signatureFile) return
            let formData = new FormData();
            formData.append("payment_type", 'cash');
            formData.append("invoice_id", this.invoice_id);
            formData.append("timestamp", new Date().getTime());
            formData.append("signature", signatureFile);
            formData.append("pac_id", this.invoiceDetail.pac_id);
            this.postCheckout(formData)
        },

        ccCheckout(payload) {
            let signatureFile = this.getSignature()
            if (!signatureFile) return
            let formData = new FormData();
            formData.append("payment_type", 'cc');
            formData.append("invoice_id", this.invoice_id);
            formData.append("card_token", payload.token.id);
            formData.append("timestamp", new Date().getTime());
            formData.append("signature", signatureFile);
            formData.append("card_id", this.creditCardIDResponse.card_id);
            formData.append("pac_id", this.invoiceDetail.pac_id);
            this.postCheckout(formData)
        },

        otherCheckout(payload) {
            let signatureFile = this.getSignature()
            if (!signatureFile) return
            let formData = new FormData();
            formData.append("payment_type", 'other');
            formData.append("invoice_id", this.invoice_id);
            formData.append("timestamp", new Date().getTime());
            formData.append("signature", signatureFile);
            formData.append("institute_id", payload.institute_id);
            formData.append("pac_id", this.invoiceDetail.pac_id);
            if (!this.$helper.isEmpty(payload.institute_name)) {
                formData.append("institute_name", payload.institute_name);
            }
            if (!this.$helper.isEmpty(payload.dealer_fee)) {
                formData.append("dealer_fee", payload.dealer_fee);
            }
            if (!this.$helper.isEmpty(payload.description)) {
                formData.append("description", payload.description);
            }
            if (!this.$helper.isEmpty(payload.plan_id)) {
                formData.append("plan_id", payload.plan_id);
            }
            this.postCheckout(formData)
        },

        checkCheckout(payload) {
            let signatureFile = this.getSignature()
            if (!signatureFile) return
            let formData = new FormData();
            formData.append("payment_type", 'check');
            formData.append("invoice_id", this.invoice_id);
            formData.append("front_image", payload.front_image);
            formData.append("back_image", payload.back_image);
            formData.append("timestamp", new Date().getTime());
            formData.append("signature", signatureFile);
            formData.append("pac_id", this.invoiceDetail.pac_id);
            this.postCheckout(formData)
        },

        uploadSignaturePaymentLinkCall() {

            window.location.href = this.stripURL

            // let signatureFile = this.getSignature()
            // if (!signatureFile) return
            // let formData = new FormData();
            // formData.append("invoice_id", this.invoice_id);
            // formData.append("timestamp", new Date().getTime());
            // formData.append("signature", signatureFile);
            // this.uploadSignaturePaymentLink(formData)
        },

        onBegin() {
            //this.isSignatureValid = false
            this.$refs.signaturePad.resizeCanvas();
            if (this.saveSignatureTimeout) {
                clearTimeout(this.saveSignatureTimeout);
            }
        },
        onEnd() {
            this.saveSignatureTimeout = setTimeout(() => {
                this.saveSignature();
            }, 1000);
            this.isSignatureValid = true
        },
        async saveSignature() {
            let result = { isEmpty: true, data: null }
            if (this.$refs.signaturePad) result = this.$refs.signaturePad.saveSignature();
            if (!result.isEmpty) {
                this.signationImageFile = await this.base64ToFile(result.data, "signature.png");
            }
        },

        base64ToFile(base64String, filename) {
            const arr = base64String.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        getSignature() {
            return this.signationImageFile
        },
        clearSignature() {
            this.$refs.signaturePad.clearSignature()
            this.isSignatureValid = false
            this.signationImageFile = null
            this.saveSignatureTimeout = null
        },
        copysharelink() {
            navigator.clipboard.writeText(this.stripURL)
            toast.success("URL copied successfully!");
        },

        financialCallback(option, data) {
            if (option == 'onTypeSelected') {
                this.isSignatureDisable = data.is_payment_link == 1 ? true : false
            } else if (option == 'onGenerateLinkClicked') {
                this.generateLinkClicked()
            }
        },

        tabClicked(id) {
            this.activeTab = id
            this.isSignatureDisable = false

        }
    }

}
</script>
<style scoped>
.scrollbar-hide::-webkit-scrollbar {
    display: none;
}

.scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

/* Scrollbar width */
.customscrolbar::-webkit-scrollbar {
    width: 4px;
    /* horizontal ke liye height bhi set karna hoga */
    height: 4px;
}

/* Track */
.customscrolbar::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 10px;
}

/* Thumb */
.customscrolbar::-webkit-scrollbar-thumb {
    background: #f1f1f1;
    border-radius: 10px;
}
</style>